function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.3682 0.000980939C20.2295 0.170475 25.6708 5.84112 25.5578 12.7044C25.4449 19.5676 19.8199 25.0561 12.9567 24.9996C6.09354 24.9431 0.559605 19.3628 0.55957 12.4986C0.645996 5.51016 6.38052 -0.085139 13.3682 0.000980939ZM20.6192 8.37442C20.1209 8.59708 19.5924 8.7445 19.0509 8.81183C19.6235 8.46412 20.0501 7.91997 20.2511 7.28087C19.7165 7.60431 19.1299 7.83264 18.5173 7.95574C18.0045 7.39858 17.282 7.08136 16.5248 7.08091C15.6857 7.08774 14.8954 7.47639 14.3777 8.13681C13.8601 8.79722 13.6713 9.6575 13.8649 10.474C11.6638 10.3562 9.6171 9.30622 8.23725 7.58706C7.51268 8.84801 7.88072 10.4543 9.082 11.2739C8.64808 11.2612 8.22375 11.1432 7.8455 10.9302C7.82663 12.2504 8.74403 13.3995 10.0355 13.6734C9.63285 13.7791 9.2118 13.794 8.80271 13.7172C9.1535 14.8375 10.1796 15.6093 11.3532 15.6356C10.2139 16.5441 8.75703 16.9562 7.31066 16.7791C8.55657 17.5895 10.0106 18.0215 11.4969 18.0226C13.6353 18.0223 15.6791 17.1411 17.1474 15.5863C18.6156 14.0315 19.3787 11.9405 19.2571 9.8054C19.7934 9.41416 20.2548 8.92941 20.6192 8.37442Z",
  fill: "#4FADF0"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "media/twitter-share-icon.ff6eda84.svg";
export { SvgComponent as ReactComponent };